module.exports = __webpack_public_path__ + "img/seal.acca9b55.png";